import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import VueSweetalert2 from "vue-sweetalert2";
Vue.use(VueSweetalert2);

import FormBuilder from "lucien-form-builder";
Vue.use(FormBuilder);

import "./main.scss";

Vue.config.productionTip = false;

console.log("process.env.NODE_ENV", process.env.NODE_ENV, process.env);

console.log("document.referrer");
console.log(document.referrer)
console.log("window");
console.log(window);
console.log("document");
console.log(document);

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
